import React from 'react';
import { bunnyPhilosophy } from '../../bunnyMock';
import { Sparkles, Zap, Star, Award } from 'lucide-react';

const icons = {
  'Fashion First': Star,
  'Confidence Always': Award,
  'Express Yourself': Sparkles,
  'Quality Matters': Zap
};

const BunnyPhilosophySection = () => {
  return (
    <section className="section-spacing bunny-section-light">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif bunny-headline text-gray-900 mb-6">
            {bunnyPhilosophy.headline}
          </h2>
          <p className="text-xl text-gray-700 font-sans max-w-3xl mx-auto leading-relaxed">
            {bunnyPhilosophy.message}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {bunnyPhilosophy.values.map((value, index) => {
            const IconComponent = icons[value.title] || Star;
            return (
              <div 
                key={index} 
                className="bunny-card p-8"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-6">
                  <div className="p-4 bg-gradient-to-br from-pink-400 to-yellow-400 rounded-full flex-shrink-0">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-serif bunny-headline text-gray-900 mb-3">
                      {value.title}
                    </h3>
                    <p className="text-base text-gray-700 font-sans leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BunnyPhilosophySection;
